"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nord = void 0;
const createColorScheme_1 = require("../createColorScheme");
exports.nord = (0, createColorScheme_1.createColorScheme)("nord", {
    bg: "#2E3440",
    fg: "#a6b4cd",
    primary: "#579190",
    secondary: "#4A7197",
}, {
    red: "#BF616A",
    green: "#A3BE8C",
    yellow: "#EBCB8B",
    blue: "#5E81AC",
    purple: "#B48EAD",
    cyan: "#88C0D0",
    orange: "#D08770",
});
